import React, { ReactNode } from "react";
type Tone = "light" | "dark";
export function Container({
  children,
  className = ""
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={`mx-auto w-full max-w-[1192px] px-5 sm:px-6 ${className}`} data-id="element-201" data-mp="33r0sygg4fjta">{children}</div>;
}
export function Eyebrow({
  children,
  tone = "light"
}: {
  children: ReactNode;
  tone?: Tone;
}) {
  return <p className={`mb-3 text-xs font-semibold uppercase tracking-[0.18em] sm:text-[13px] ${tone === "dark" ? "text-sage" : "text-petrol"}`} data-id="element-202" data-mp="3dl97g08bhc8g">
      {children}
    </p>;
}
export function Accent({
  children,
  tone = "light"
}: {
  children: ReactNode;
  tone?: Tone;
}) {
  return <span className={tone === "dark" ? "text-sage" : "text-petrol"} data-id="element-203" data-mp="2zp5hwk8e1s2b">{children}</span>;
}
export function H2({
  children,
  tone = "light",
  className = ""
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return <h2 className={`font-display text-[clamp(32px,5vw,60px)] font-extrabold uppercase leading-[0.95] tracking-[-0.01em] ${tone === "dark" ? "text-white" : "text-ink"} ${className}`} data-id="element-204" data-mp="a2g74p4jujw8">
      {children}
    </h2>;
}
export function SectionHeader({
  eyebrow,
  title,
  lead,
  tone = "light"
}: {
  eyebrow: string;
  title: ReactNode;
  lead?: string;
  tone?: Tone;
}) {
  return <div className="mx-auto mb-8 max-w-[760px] text-center md:mb-14" data-id="element-205" data-mp="1b48ciauntp48">
      <Eyebrow tone={tone} data-id="element-206" data-mp="edoah8fl58f8">{eyebrow}</Eyebrow>
      <H2 tone={tone} data-id="element-207" data-mp="eezbx1lk6436">{title}</H2>
      {lead && <p className={`mt-4 text-base sm:text-lg ${tone === "dark" ? "text-white/80" : "text-muted"}`} data-id="element-208" data-mp="jcsi3umv2y3g">{lead}</p>}
    </div>;
}
type CtaProps = {
  href: string;
  children: ReactNode;
  className?: string;
  compact?: boolean;
  onClick?: () => void;
};
export function CtaButton({
  href,
  children,
  className = "",
  compact = false,
  onClick
}: CtaProps) {
  const size = compact ? "min-h-[48px] px-4 py-2.5 text-sm shadow-[0_5px_0_#7E3320] active:shadow-[0_2px_0_#7E3320] sm:px-6 sm:text-base" : "mb-2 min-h-[60px] px-6 py-4 text-lg shadow-[0_7px_0_#7E3320,0_14px_28px_rgba(181,78,49,0.2)] active:shadow-[0_3px_0_#7E3320] sm:min-h-[64px] sm:px-8 sm:text-[21px]";
  return <a href={href} onClick={onClick} className={`inline-flex items-center justify-center whitespace-nowrap rounded-xl bg-terra text-center font-bold uppercase leading-tight text-white no-underline transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-terra-hover active:translate-y-1 motion-reduce:transition-none ${size} ${className}`} data-id="element-209" data-mp="xyrwp1a2j9ag">
      {children}
    </a>;
}